import { Injectable } from '@angular/core'
import { Observable, pipe } from 'rxjs'
import {
  CONTAINER_CAPACITY_CBM,
  RFQ_CALCULATION_DECIMAL_PLACES,
} from './rfq-pricing-constants'


@Injectable()
export class rfqEquation {
  constructor() {
  }
  setGenFobMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_fob_margin') {
        params.newValue = params.data[this.getMasterFiledName('gen_fob_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_fob_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let deduction = this.getDeduction(0, margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let cost_incl_agent_comm = this.getCostInclAgentComm(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)]);
      let value = this.getSellPrice(cost_incl_agent_comm, deduction)
      params.data[this.getMasterFiledName('gen_fob_sell_price', colHeaders)] = value;
    }

    params.data['rfqItem_gen_fob_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('gen_fob_margin', colHeaders)] = params.newValue;
  }

  setGenFobSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_fob_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('gen_fob_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_fob_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(0, 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2)
      let fob_total_cost = this.getFobTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)])
      let value = this.getMargin(netsellPrice, fob_total_cost, params.newValue);
      params.data[this.getMasterFiledName('gen_fob_margin', colHeaders)] = value;
    }
    params.data['rfqItem_gen_fob_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('gen_fob_sell_price', colHeaders)] = params.newValue;
  }

  setGenMddpMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_mddp_margin') {
        params.newValue = params.data[this.getMasterFiledName('gen_mddp_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_mddp_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let deduction = this.getDeduction(0, margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let mddp_total_cost = this.getMddpTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data.duty_rate_dollar_amount)
      let value = this.getSellPrice(mddp_total_cost, deduction)
      params.data[this.getMasterFiledName('gen_mddp_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_gen_mddp_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('gen_mddp_margin', colHeaders)] = params.newValue;
  }

  setGenMddpSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_mddp_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('gen_mddp_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_mddp_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(0, 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let mddp_total_cost = this.getMddpTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, mddp_total_cost, params.newValue);
      params.data[this.getMasterFiledName('gen_mddp_margin', colHeaders)] = value;
    }
    params.data['rfqItem_gen_mddp_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('gen_mddp_sell_price', colHeaders)] = params.newValue;
  }

  setGenPoeMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_poe_margin') {
        params.newValue = params.data[this.getMasterFiledName('gen_poe_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_poe_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let poe_total_cost = this.getPoeTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data.duty_rate_dollar_amount)
      let deduction = this.getDeduction(0, margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(poe_total_cost, deduction)
      params.data[this.getMasterFiledName('gen_poe_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_gen_poe_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('gen_poe_margin', colHeaders)] = params.newValue;
  }
  setGenPoeSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_poe_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('gen_poe_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_poe_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(0, 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let poe_total_cost = this.getPoeTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, poe_total_cost, params.newValue);
      params.data[this.getMasterFiledName('gen_poe_margin', colHeaders)] = value;
    }
    params.data['rfqItem_gen_poe_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('gen_poe_sell_price', colHeaders)] = params.newValue;
  }

  setGenWhseMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_whse_margin') {
        params.newValue = params.data[this.getMasterFiledName('gen_whse_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_whse_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let whse_total_cost = this.getWhseTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data['whsecost'], params.data[this.getMasterFiledName('cbm_pc', colHeaders)], params.data.duty_rate_dollar_amount)
      let deduction = this.getDeduction(0, margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(whse_total_cost, deduction)
      params.data[this.getMasterFiledName('gen_whse_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_gen_whse_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('gen_whse_margin', colHeaders)] = params.newValue;
  }

  setGenWhseSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'gen_whse_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('gen_whse_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('gen_whse_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(0, 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let whse_total_cost = this.getWhseTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data['whsecost'], params.data[this.getMasterFiledName('cbm_pc', colHeaders)], params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, whse_total_cost, params.newValue);
      params.data[this.getMasterFiledName('gen_whse_margin', colHeaders)] = value;
    }
    params.data['rfqItem_gen_whse_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('gen_whse_sell_price', colHeaders)] = params.newValue;
  }

  setLicFobMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_fob_margin') {
        params.newValue = params.data[this.getMasterFiledName('lic_fob_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_fob_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let fob_total_cost = this.getFobTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)])
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_fob_royalty', colHeaders)], margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(fob_total_cost, deduction)
      params.data[this.getMasterFiledName('lic_fob_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_lic_fob_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('lic_fob_margin', colHeaders)] = params.newValue;
  }

  setLicFobSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_fob_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('lic_fob_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_fob_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_fob_royalty', colHeaders)], 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let fob_total_cost = this.getFobTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)])
      let value = this.getMargin(netsellPrice, fob_total_cost, params.newValue);
      params.data[this.getMasterFiledName('lic_fob_margin', colHeaders)] = value;
    }
    params.data['rfqItem_lic_fob_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('lic_fob_sell_price', colHeaders)] = params.newValue;
  }

  setLicMddpMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_mddp_margin') {
        params.newValue = params.data[this.getMasterFiledName('lic_mddp_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_mddp_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let mddp_total_cost = this.getMddpTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data.duty_rate_dollar_amount)
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_mddp_royalty', colHeaders)], margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(mddp_total_cost, deduction)
      params.data[this.getMasterFiledName('lic_mddp_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_lic_mddp_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('lic_mddp_margin', colHeaders)] = params.newValue;
  }

  setLicMddpSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_mddp_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('lic_mddp_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_mddp_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_mddp_royalty', colHeaders)], 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let mddp_total_cost = this.getMddpTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, mddp_total_cost, params.newValue);
      params.data[this.getMasterFiledName('lic_mddp_margin', colHeaders)] = value;
    }
    params.data['rfqItem_lic_mddp_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('lic_mddp_sell_price', colHeaders)] = params.newValue;
  }

  setLicPoeMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_poe_margin') {
        params.newValue = params.data[this.getMasterFiledName('lic_poe_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_poe_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let poe_total_cost = this.getPoeTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data.duty_rate_dollar_amount)
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_poe_royalty', colHeaders)], margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(poe_total_cost, deduction)
      params.data[this.getMasterFiledName('lic_poe_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_lic_poe_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('lic_poe_margin', colHeaders)] = params.newValue;
  }

  setLicPoeSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_poe_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('lic_poe_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_poe_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_poe_royalty', colHeaders)], 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let poe_total_cost = this.getPoeTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, poe_total_cost, params.newValue);
      params.data[this.getMasterFiledName('lic_poe_margin', colHeaders)] = value;
    }
    params.data['rfqItem_lic_poe_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('lic_poe_sell_price', colHeaders)] = params.newValue;
  }

  setLicWhseMargin(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_whse_margin') {
        params.newValue = params.data[this.getMasterFiledName('lic_whse_margin', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_whse_margin', colHeaders)]
    }
    if (params.newValue) {
      let margin = (parseFloat(params.newValue))
      let whse_total_cost = this.getWhseTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data['whsecost'], params.data[this.getMasterFiledName('cbm_pc', colHeaders)], params.data.duty_rate_dollar_amount)
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_whse_royalty', colHeaders)], margin, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let value = this.getSellPrice(whse_total_cost, deduction)
      params.data[this.getMasterFiledName('lic_whse_sell_price', colHeaders)] = value;
    }
    params.data['rfqItem_lic_whse_entered_margin'] = params.newValue;
    params.data[this.getMasterFiledName('lic_whse_margin', colHeaders)] = params.newValue;
  }

  setLicWhseSellPrice(params, colHeaders) {
    if (params.column) {
      if (params.column.getColDef?.()?.colId != 'lic_whse_sell_price') {
        params.newValue = params.data[this.getMasterFiledName('lic_whse_sell_price', colHeaders)]
      }
    } else {
      params.newValue = params.data[this.getMasterFiledName('lic_whse_sell_price', colHeaders)]
    }
    if (params.newValue) {
      let deduction = this.getDeduction(params.data[this.getMasterFiledName('lic_whse_royalty', colHeaders)], 0, params.data[this.getMasterFiledName('logistics_load', colHeaders)], parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]))
      let netsellPrice = (parseFloat(params.newValue) * (parseFloat(deduction))).toFixed(2);
      let whse_total_cost = this.getWhseTotalCost(params.data[this.getMasterFiledName('fob_cost', colHeaders)], params.data[this.getMasterFiledName('agent', colHeaders)], params.data[this.getMasterFiledName('duty_rate', colHeaders)]?.title, params.data[this.getMasterFiledName('freight', colHeaders)], params.data['whsecost'], params.data[this.getMasterFiledName('cbm_pc', colHeaders)], params.data.duty_rate_dollar_amount)
      let value = this.getMargin(netsellPrice, whse_total_cost, params.newValue);
      params.data[this.getMasterFiledName('lic_whse_margin', colHeaders)] = value;
    }
    params.data['rfqItem_lic_whse_entered_sell_price'] = params.newValue;
    params.data[this.getMasterFiledName('lic_whse_sell_price', colHeaders)] = params.newValue;
  }

  getMasterFiledName(colId, colHeaders, required = true) {
    const header = colHeaders.find((candidate) =>
      (candidate.colId ?? candidate.col_id) === colId
    );
    if (header?.field) {
      return header.field;
    }
    if (!required) {
      return null;
    }
    throw new Error(`[rfqEquation] Missing field mapping for "${colId}".`);
  }

  getFobTotalCost(fobCost, AgentComm) {
    if (fobCost == null || fobCost == '' || fobCost == undefined || AgentComm == 'undefined') {
      fobCost = 0
    } else {
      fobCost = parseFloat(fobCost)
    }
    if (AgentComm == null || AgentComm == '' || AgentComm == undefined || AgentComm == 'undefined') {
      AgentComm = 0
    } else {
      AgentComm = parseFloat(AgentComm)
    }
    //factory price
    return fobCost * (1 + AgentComm / 100);
  }

  getMddpTotalCost(fobCost, AgentComm, dutyRate, dutyDollar) {
    if (fobCost == null || fobCost == '' || fobCost == undefined || fobCost == 'undefined') {
      fobCost = 0
    } else {
      fobCost = parseFloat(fobCost)
    }
    if (AgentComm == null || AgentComm == '' || AgentComm == undefined || AgentComm == 'undefined') {
      AgentComm = 0
    } else {
      AgentComm = parseFloat(AgentComm)
    }
    if (dutyRate == null || dutyRate == '' || dutyRate == undefined || dutyRate == 'undefined') {
      dutyRate = 0
    } else {
      dutyRate = parseFloat(dutyRate)
    }
    if (dutyDollar == null || dutyDollar == '' || dutyDollar == undefined || dutyDollar == 'undefined') {
      dutyDollar = 0
    } else {
      dutyDollar = parseFloat(dutyDollar)
    }
    let cost_incl_agent_comm = (fobCost * (1 + AgentComm / 100));
    let cost_incl_duty_agent = (cost_incl_agent_comm * (1 + (dutyRate / 100)) + dutyDollar).toFixed(RFQ_CALCULATION_DECIMAL_PLACES)
    
    return cost_incl_duty_agent;
  }

  getPoeTotalCost(fobCost, AgentComm, dutyRate, freight, dutyDollar) {
    if (fobCost == null || fobCost == '' || fobCost == undefined || fobCost == 'undefined') {
      fobCost = 0
    } else {
      fobCost = parseFloat(fobCost)
    }
    if (AgentComm == null || AgentComm == '' || AgentComm == undefined || AgentComm == 'undefined') {
      AgentComm = 0
    } else {
      AgentComm = parseFloat(AgentComm)
    }
    if (freight == null || freight == '' || freight == undefined || freight == 'undefined') {
      freight = 0
    } else {
      freight = parseFloat(freight)
    }
    if (dutyRate == null || dutyRate == '' || dutyRate == undefined || dutyRate == 'undefined') {
      dutyRate = 0
    } else {
      dutyRate = parseFloat(dutyRate)
    }
    if (dutyDollar == null || dutyDollar == '' || dutyDollar == undefined || dutyDollar == 'undefined') {
      dutyDollar = 0
    } else {
      dutyDollar = parseFloat(dutyDollar)
    }
    return ((fobCost * (1 + (AgentComm / 100))) * (1 + (dutyRate / 100)) + dutyDollar) + freight;
  }
  getWhseTotalCost(fobCost, AgentComm, dutyRate, freight, whsesCost, cbm_pc, dutyDollar) {
    if (fobCost == null || fobCost == '' || fobCost == undefined || fobCost == 'undefined') {
      fobCost = 0
    } else {
      fobCost = parseFloat(fobCost)
    }
    if (AgentComm == null || AgentComm == '' || AgentComm == undefined || AgentComm == 'undefined') {
      AgentComm = 0
    } else {
      AgentComm = parseFloat(AgentComm)
    }
    if (freight == null || freight == '' || freight == undefined || freight == 'undefined') {
      freight = 0
    } else {
      freight = parseFloat(freight)
    }
    if (dutyRate == null || dutyRate == '' || dutyRate == undefined || dutyRate == 'undefined') {
      dutyRate = 0
    } else {
      dutyRate = parseFloat(dutyRate)
    }
    if (whsesCost == null || whsesCost == '' || whsesCost == undefined || whsesCost == 'undefined') {
      whsesCost = 0
    } else {
      whsesCost = parseFloat(whsesCost)
    }
    if (cbm_pc == null || cbm_pc == '' || cbm_pc == undefined || cbm_pc == 'undefined') {
      cbm_pc = 0
    } else {
      cbm_pc = parseFloat(cbm_pc)
    }
    if (dutyDollar == null || dutyDollar == '' || dutyDollar == undefined || dutyDollar == 'undefined') {
      dutyDollar = 0
    } else {
      dutyDollar = parseFloat(dutyDollar)
    }
    let whse_total_cost = ((whsesCost / CONTAINER_CAPACITY_CBM) * cbm_pc).toFixed(2);
    let costInclDutyAgent = ((fobCost * (1 + (AgentComm / 100))) * (1 + (dutyRate / 100)) + dutyDollar).toFixed(RFQ_CALCULATION_DECIMAL_PLACES);
    let ldp_port = (parseFloat(costInclDutyAgent) + parseFloat(freight)).toFixed(RFQ_CALCULATION_DECIMAL_PLACES);
    let ldp_whse = (parseFloat(whse_total_cost) + parseFloat(ldp_port)).toFixed(RFQ_CALCULATION_DECIMAL_PLACES);
    return ldp_whse;
  }

  getDeduction(royalty, margin, lgload, dilution) {
    if (royalty == null || royalty == '' || royalty == undefined || royalty == 'undefined') {
      royalty = 0
    } else {
      royalty = parseFloat(royalty)
    }
    if (margin == null || margin == '' || margin == undefined || margin == 'undefined') {
      margin = 0
    } else {
      margin = parseFloat(margin)
    }
    if (lgload == null || lgload == '' || lgload == undefined || lgload == 'undefined') {
      lgload = 0
    } else {
      lgload = parseFloat(lgload)
    }
    if (dilution == null || dilution == '' || dilution == undefined || dilution == 'undefined' || isNaN(dilution)) {
      dilution = 0
    } else {
      dilution = parseFloat(dilution)
    }
    let deduction = (1 - (royalty + margin + lgload + dilution) / 100).toFixed(4);
    return deduction.toString();
    //let deduction = (royalty + margin + lgload + dilution).toFixed(2);
    //return deduction;
  }

  getSellPrice(totalCost, deduction) {
    //totalcost is net buy price (vendor)
    if (totalCost == null || totalCost == '' || totalCost == undefined || totalCost == 'undefined') {
      totalCost = 0
    } else {
      totalCost = parseFloat(totalCost)
    }
    if (deduction == null || deduction == '' || deduction == undefined || deduction == 'undefined') {
      deduction = 0
    } else {
      deduction = parseFloat(deduction)
    }
    // R2 guard: when the deduction factor (1 - royalty% - dilution% - logistics% - margin%)
    // is zero or negative, the combined deductions are >= 100% and the sell price is
    // mathematically undefined. Dividing here would write Infinity / a negative price to
    // the row. Return null instead so no garbage price is persisted, and flag it.
    // NOTE: behavior for valid (positive) deductions is unchanged — same
    // `(totalCost / deduction).toFixed(2)` as before. Gen FOB math is preserved.
    if (!(deduction > 0)) {
      console.warn(
        `[getSellPrice] non-positive deduction factor (${deduction}); deductions >= 100%. ` +
        `Skipping sell-price calc to avoid Infinity/negative price.`
      );
      return null;
    }
    let sellPrice;
    return sellPrice = (totalCost / deduction).toFixed(2);

  }
  getMargin(netSellPrice, TotalCost, GrossSellPrice) {
    if (netSellPrice == null || netSellPrice == '' || netSellPrice == undefined || netSellPrice == 'undefined') {
      netSellPrice = 0
    } else {
      netSellPrice = parseFloat(netSellPrice)
    }
    if (TotalCost == null || TotalCost == '' || TotalCost == undefined || TotalCost == 'undefined') {
      TotalCost = 0
    } else {
      TotalCost = parseFloat(TotalCost)
    }
    if (GrossSellPrice == null || GrossSellPrice == '' || GrossSellPrice == undefined || GrossSellPrice == 'undefined') {
      GrossSellPrice = 0
    } else {
      GrossSellPrice = parseFloat(GrossSellPrice)
    }

    let margin;
    if (!(GrossSellPrice > 0)) {
      console.warn(
        `[getMargin] non-positive gross sell price (${GrossSellPrice}); ` +
        `Skipping margin calc to avoid Infinity/NaN.`
      );
      return null;
    }
    margin = ((netSellPrice - TotalCost) / GrossSellPrice) * 100
    return margin.toFixed(4);

  }

  getCostInclAgentComm(fobcost, agent) {
    if (fobcost == null || fobcost == '' || fobcost == undefined || fobcost == 'undefined') {
      fobcost = 0
    } else {
      fobcost = parseFloat(fobcost)
    }
    if (agent == null || agent == '' || agent == undefined || agent == 'undefined') {
      agent = 0
    } else {
      agent = parseFloat(agent)
    }
    return (parseFloat(fobcost) * (1 + (parseFloat(agent) / 100))).toFixed(2);
  }

  getCostInclDutyAgent(cost_incl_agent_comm, duty_percent, duty_rate_dollar_amount) {
    if (cost_incl_agent_comm == null || cost_incl_agent_comm == '' || cost_incl_agent_comm == undefined || cost_incl_agent_comm == 'undefined') {
      cost_incl_agent_comm = 0
    } else {
      cost_incl_agent_comm = parseFloat(cost_incl_agent_comm)
    }
    if (duty_percent == null || duty_percent == '' || duty_percent == undefined || duty_percent == 'undefined') {
      duty_percent = 0
    } else {
      duty_percent = parseFloat(duty_percent)
    }
    if (duty_rate_dollar_amount == null || duty_rate_dollar_amount == '' || duty_rate_dollar_amount == undefined || duty_rate_dollar_amount == 'undefined') {
      duty_rate_dollar_amount = 0
    } else {
      duty_rate_dollar_amount = parseFloat(duty_rate_dollar_amount)
    }
    return (parseFloat(cost_incl_agent_comm) * (1 + (parseFloat(duty_percent) / 100)) + duty_rate_dollar_amount).toFixed(2);
  }

  getWhseCost(cbm, whse) {
    if (cbm == null || cbm == '' || cbm == undefined || cbm == 'undefined') {
      cbm = 0
    } else {
      cbm = parseFloat(cbm)
    }
    if (whse == null || whse == '' || whse == undefined || whse == 'undefined') {
      whse = 0
    } else {
      whse = parseFloat(whse)
    }
    return (cbm * whse).toFixed(2);
  }

  getLdpPort(cost_incl_duty_agent, freight) {
    if (cost_incl_duty_agent == null || cost_incl_duty_agent == '' || cost_incl_duty_agent == undefined || cost_incl_duty_agent == 'undefined') {
      cost_incl_duty_agent = 0
    } else {
      cost_incl_duty_agent = parseFloat(cost_incl_duty_agent)
    }
    if (freight == null || freight == '' || freight == undefined || freight == 'undefined') {
      freight = 0
    } else {
      freight = parseFloat(freight)
    }
    return (cost_incl_duty_agent + freight).toFixed(2);
  }

  // ── Buyer Target → Buyer Margin % (Scenario 2) ─────────────────────────────
  // The salesman types a target $ price into `{type}_buyer_target`; we report the
  // gross margin that price yields into `{type}_buyer_margin`. Reuses the exact
  // Scenario-2 math already used by the set…SellPrice functions (getMargin), but
  // reads/writes the dedicated buyer_* fields so the sourcing team's real quote is
  // untouched. Stores a real number (parseFloat) into the numeric DOUBLE column.
  // See designflow-frontend/docs/rfq-buyer-margin-plan.md.
  BUYER_MARGIN_TYPES = [
    { type: 'gen_fob',  incoterm: 'fob',  royalty: 0 },
    { type: 'gen_mddp', incoterm: 'mddp', royalty: 0 },
    { type: 'gen_poe',  incoterm: 'poe',  royalty: 0 },
    { type: 'gen_whse', incoterm: 'whse', royalty: 0 },
    { type: 'lic_fob',  incoterm: 'fob',  royalty: 'lic_fob_royalty' },
    { type: 'lic_mddp', incoterm: 'mddp', royalty: 'lic_mddp_royalty' },
    { type: 'lic_poe',  incoterm: 'poe',  royalty: 'lic_poe_royalty' },
    { type: 'lic_whse', incoterm: 'whse', royalty: 'lic_whse_royalty' },
  ];

  getBuyerCostBasis(incoterm, params, colHeaders) {
    const d = (colId) => params.data[this.getMasterFiledName(colId, colHeaders)];
    switch (incoterm) {
      case 'fob':
        return this.getFobTotalCost(d('fob_cost'), d('agent'));
      case 'mddp':
        return this.getMddpTotalCost(d('fob_cost'), d('agent'), d('duty_rate')?.title, params.data.duty_rate_dollar_amount);
      case 'poe':
        return this.getPoeTotalCost(d('fob_cost'), d('agent'), d('duty_rate')?.title, d('freight'), params.data.duty_rate_dollar_amount);
      case 'whse':
        return this.getWhseTotalCost(d('fob_cost'), d('agent'), d('duty_rate')?.title, d('freight'), params.data['whsecost'], d('cbm_pc'), params.data.duty_rate_dollar_amount);
      default:
        return 0;
    }
  }

  setBuyerMargin(cfg, params, colHeaders) {
    const targetField = this.getMasterFiledName(cfg.type + '_buyer_target', colHeaders, false);
    const marginField = this.getMasterFiledName(cfg.type + '_buyer_margin', colHeaders, false);
    // Columns absent (e.g. user lacks the toggle) → nothing to compute.
    if (!targetField || !marginField) return;

    const target = params.data[targetField];
    const targetNum = parseFloat(target);
    // Blank/invalid or non-positive target → no margin. Guards divide-by-zero in
    // getMargin (GrossSellPrice = target), which would otherwise write Infinity.
    if (target === null || target === undefined || target === '' || isNaN(targetNum) || targetNum <= 0) {
      params.data[marginField] = null;
      return;
    }
    const royalty = typeof cfg.royalty === 'number'
      ? cfg.royalty
      : params.data[this.getMasterFiledName(cfg.royalty, colHeaders)];
    const logistics = params.data[this.getMasterFiledName('logistics_load', colHeaders)];
    const dilution = parseFloat(params.data[this.getMasterFiledName('dilution', colHeaders)]);
    // margin excluded from the deduction here — we are solving FOR the margin.
    const deduction = this.getDeduction(royalty, 0, logistics, dilution);
    const netSellPrice = (parseFloat(target) * parseFloat(deduction)).toFixed(2);
    const costBasis = this.getBuyerCostBasis(cfg.incoterm, params, colHeaders);
    const margin = this.getMargin(netSellPrice, costBasis, target);
    // Store a real number into the numeric DOUBLE column (getMargin returns a string).
    params.data[marginField] = (margin === null || margin === undefined || isNaN(parseFloat(margin)))
      ? null
      : parseFloat(margin);
  }

  recalculate_Buyer_Margins(params, colHeaders) {
    try {
      for (const cfg of this.BUYER_MARGIN_TYPES) {
        this.setBuyerMargin(cfg, params, colHeaders);
      }
    } catch (e) {
      console.error('[recalculate_Buyer_Margins] error:', e);
    }
  }

  recalculate_Lic_Gen(params, colHeaders) {
    try {
      this.setGenFobMargin(params, colHeaders);
      // this.setGenFobSellPrice(params, colHeaders);
      this.setGenMddpMargin(params, colHeaders);
      // this.setGenMddpSellPrice(params, colHeaders);
      this.setGenPoeMargin(params, colHeaders);
      // this.setGenPoeSellPrice(params, colHeaders);
      this.setGenWhseMargin(params, colHeaders);
      //   this.setGenWhseSellPrice(params, colHeaders);
      this.setLicFobMargin(params, colHeaders);
      //  this.setLicFobSellPrice(params, colHeaders);
      this.setLicMddpMargin(params, colHeaders);
      //  this.setLicMddpSellPrice(params, colHeaders);
      this.setLicPoeMargin(params, colHeaders);
      //  this.setLicPoeSellPrice(params, colHeaders);
      this.setLicWhseMargin(params, colHeaders);
      //  this.setLicWhseSellPrice(params, colHeaders);
      // Refresh salesman Buyer Margins too — their cost basis / deductions depend on
      // the same inputs (fob_cost, agent, duty, freight, cbm, royalty, dilution, logistics).
      this.recalculate_Buyer_Margins(params, colHeaders);
    } catch (e) {
      console.error('[recalculate_Lic_Gen] margin recalculation error:', e);
    }
  }
}
